import { render } from "./higienizar-whatsapp.vue?vue&type=template&id=236c8968&scoped=true"
import script from "./higienizar-whatsapp.vue?vue&type=script&lang=js"
export * from "./higienizar-whatsapp.vue?vue&type=script&lang=js"

import "./higienizar-whatsapp.vue?vue&type=style&index=0&id=236c8968&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c8968"]])

export default __exports__